const experience = [
  {
    id: 'athos',
    company: 'Athos Commerce',
    title: 'Software Engineer II',
    period: 'Jul 2025 — Present',
    location: 'San Antonio, TX · Remote',
    url: 'https://athoscommerce.com',
    bullets: [
      'Respond to customer inquiries with timely, helpful support — troubleshooting and resolving technical issues end-to-end.',
      'Research, diagnose, and identify effective solutions across a wide range of customer challenges.',
      'Peer review and ship code to production on a regular release cadence.',
      'Contribute to internal knowledge sharing through technical documentation and KB articles.',
    ],
    stack: ['JavaScript', 'Preact', 'HTML5', 'CSS3', 'Groovy', 'AWS', 'Shopify', 'Magento', 'BigCommerce', 'Git'],
    images: [
      { src: 'https://i.imgur.com/Ej8Eaks.png', alt: 'Athos website' },
      { src: 'https://i.imgur.com/m6e88t8.png', alt: 'Athos generative discovery' },
    ],
  },
  {
    id: 'searchspring',
    company: 'Searchspring',
    title: 'Software Engineer I',
    period: 'Feb 2024 — Jul 2025',
    location: 'San Antonio, TX · Remote',
    url: 'https://searchspring.com',
    bullets: [
      'Responded to customer inquiries and assisted in troubleshooting and resolving challenges.',
      'Researched, diagnosed, and identified solutions to resolve customer issues.',
      'Provided prompt and accurate feedback to customers.',
      'Reviewed and published code to production.',
      'Documented knowledge in the form of KB tech notes and articles.',
    ],
    stack: ['JavaScript', 'Preact', 'HTML5', 'CSS3', 'Groovy', 'AWS', 'Shopify', 'Magento', 'BigCommerce', 'Git'],
    images: [
      { src: 'https://i.imgur.com/5gKYddR.jpg', alt: 'Searchspring product' },
      { src: 'https://i.imgur.com/MkI2nef.jpg', alt: 'Searchspring autocomplete' },
      { src: 'https://i.imgur.com/bwpervB.jpg', alt: 'Searchspring partners' },
    ],
  },
  {
    id: 'guild',
    company: 'Guild Gaming',
    title: 'Jr Software Engineer',
    period: 'May 2023 — Mar 2024',
    location: 'San Marcos, TX · Remote',
    url: 'https://www.guildgaming.gg',
    bullets: [
      'Created UX/UI components using React, TypeScript, and Tailwind.',
      'Unit-tested edge cases and eliminated bugs with Jest.',
      'Weekly scrum updates, department and team communication.',
      'Used ReactQuill, ReactQuery, and reCAPTCHA for form functionality and validation.',
      'Assisted the Marketing team with cold calling and market strategy.',
    ],
    stack: ['React', 'TypeScript', 'HTML5', 'Tailwind', 'PostgreSQL', 'Node.js', 'Git', 'Figma'],
    images: [
      { src: 'https://i.imgur.com/2bISWJX.jpg', alt: 'Guild Gaming map icons' },
      { src: 'https://i.imgur.com/UAAyOCu.jpg', alt: 'Guild Gaming mobile map' },
      { src: 'https://i.imgur.com/J4nXg66.jpg', alt: 'Guild Gaming certificate' },
    ],
  },
  {
    id: 'fullstack',
    company: 'Fullstack Academy',
    title: 'Engineering Student',
    period: 'Sept 2022 — Dec 2022',
    location: 'New York, NY · Remote',
    url: 'https://www.fullstackacademy.com',
    bullets: [
      'Full-time 12-week immersive software engineering and web development bootcamp.',
      'Weekly personal and group projects focused on JavaScript, React, Express, Node.js, and PostgreSQL.',
      'Demonstrated full-stack web development skills and teamwork.',
      'Capstone: built a fully functional e-commerce web application from the ground up with a team of four — deployed both front and back end and presented the finished project to graduate.',
    ],
    stack: ['React', 'JavaScript', 'HTML5', 'CSS3', 'Node.js', 'Git', 'Netlify', 'Render'],
    images: [
      { src: 'https://i.imgur.com/WlkF9rt.png', alt: 'Fullstack Academy certificate' },
    ],
  },
];

export default experience;
